// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-socials__links[data-v-f59e6c54]{display:grid;grid-template-columns:1fr;grid-gap:20px;margin:24px 0;max-height:40vh;overflow-y:auto}.edit-socials__buttons[data-v-f59e6c54]{display:grid;grid-template-columns:max-content max-content;grid-gap:16px;align-items:center;justify-content:end}.edit-socials__button[data-v-f59e6c54]{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
